import axios from 'axios';
import { BASEURL } from '../Config';

// Centralized Axios instance
const api = axios.create({
  baseURL: BASEURL,
});

// Attach Authorization header from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    if (!config.headers) config.headers = {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Optional: basic 401 handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // Clear token on unauthorized
      try { localStorage.removeItem('token'); } catch (_) {}
    }
    return Promise.reject(error);
  }
);

export default api;


